<template>
	<v-card>
		<v-card-text>
			<div class="d-flex flex-row align-center">
				<date-picker v-model="form.date" label="选择日期"></date-picker>
			</div>
			<div class="d-flex flex-row align-center flexwrap">
				<template v-if="selectedBean">
					{{ selectedBean.name }}
				</template>
				<bean-selector @selected="onBeanSelected">选择豆</bean-selector>
				类型
				<v-radio-group v-model="form.bean_type" inline>
					<v-radio
						v-for="item in refs['BeanType']"
						:key="item.value"
						:label="item.title"
						:error-messages="errors.type"
						:value="item.value"
					></v-radio>
				</v-radio-group>
				<span v-if="form.bean_type == 'roasted'" style="color: brown; font-weight: bolder">
					{{ selectedBean.roastedstock }}克 ({{ selectedBean.cprice }}元/千克)
				</span>
				<span v-if="form.bean_type == 'green'" style="color: green">
					{{ selectedBean.rawstock }}克 ({{ selectedBean.purchaseprice }}元/千克)
				</span>
				<v-alert type="error" v-if="!form.bean_id && errors.bean_id">{{ errors.bean_id }}</v-alert>
			</div>
			<div class="d-flex flex-row align-center">
				<v-text-field
					type="number"
					v-model.number="form.totalqty"
					:error-messages="errors.totalqty"
					style="max-width: 10rem"
				></v-text-field>
				克
				<v-text-field
					type="number"
					label="总价值"
					v-model.number="form.totalprice"
					:error-messages="errors.totalprice"
					style="max-width: 10rem"
				></v-text-field>
				元
			</div>
			<div class="d-flex flex-row align-center">
				入库类型：
				<v-radio-group v-model="form.type" inline :error-messages="errors.type">
					<v-radio
						v-for="item in refs['StockLogInType']"
						:key="item.value"
						:label="item.title"
						:value="item.value"
					></v-radio>
				</v-radio-group>
			</div>
			<div v-if="form.type == 'purchase'">
				<v-img
					class="d-inline-block mr-1"
					v-for="item in form.receipts"
					:key="item"
					:src="item"
					contain
					width="100"
					height="100"
					@click="showImg(item)"
				/>
				<image-uploader label="图片" model-value="" @uploaded="onReceiptUploaded">
					<template #default="{ trigger, progress }">
						<v-btn @click="trigger">上传凭证图片</v-btn>
						<v-progress-linear
							v-if="progress > 0 && progress < 100"
							:model-value="progress"
							color="blue"
							height="10"
						></v-progress-linear>
					</template>
				</image-uploader>
			</div>
			<div>
				<v-textarea v-model="form.memo" label="备注" rows="1" variant="outlined"></v-textarea>
			</div>
		</v-card-text>
		<v-card-actions>
			<slot name="actions" :object="form"></slot>
		</v-card-actions>
	</v-card>
	<v-dialog v-model="popupDlg" width="80%">
		<v-img :src="popupUrl" contain style="max-height: 80vh" />
	</v-dialog>
</template>

<script>
import DatePicker from '../common/DatePicker.vue'
import ImageUploader from '../common/ImageUploader.vue'
import BeanSelector from './Selector.vue'
import { clone } from 'lodash-es'

export default {
	components: {
		BeanSelector,
		DatePicker,
		ImageUploader
	},
	props: {
		value: { type: Object, default: null },
		errors: { type: Object, default: () => ({}) }
	},
	mounted() {
		this.$api.common.meta('bean', 'BeanType,StockLogInType', (res) => {
			this.refs = res
		})
		if (this.value) {
			this.form = clone(this.value)
			if (this.form.bean_id) this.loadBean(this.form.bean_id)
		}
	},
	watch: {
		'form.bean_id'(v) {
			if (v) this.loadBean(v)
		},
		value(v) {
			if (v) this.form = clone(v)
		},
		'form.totalqty'(v) {
			this.calcTotalPrice()
		},
		'form.bean_type'(v) {
			this.calcTotalPrice()
		}
	},
	data() {
		return {
			form: {
				date: null,
				bean_id: null,
				type: null,
				totalqty: 0,
				totalprice: 0
			},
			menu: false,
			selectedBean: {},
			refs: {},
			popupDlg: false,
			popupUrl: null
		}
	},
	computed: {},
	methods: {
		showImg(url) {
			this.popupDlg = true
			this.popupUrl = url
		},
		loadBean(id) {
			this.$api.bean.getById(id, (res) => {
				this.selectedBean = res
				this.calcTotalPrice()
			})
		},
		calcTotalPrice() {
			console.log('calcTotalPrice', this.form.bean_type, this.selectedBean)
			if (this.form.bean_type && this.selectedBean) {
				if (this.form.bean_type == 'green') {
					this.form.totalprice = (this.selectedBean.purchaseprice / 1000) * this.form.totalqty
				}
				if (this.form.bean_type == 'roasted') {
					this.form.totalprice = (this.selectedBean.cprice / 1000) * this.form.totalqty
				}
			}
		},
		onBeanSelected(beanids, beans) {
			this.form.bean_id = beanids[0]
			this.selectedBean = beans[0]
		},
		onReceiptUploaded(urls) {
			if (!this.form.receipts) this.form.receipts = []
			this.form.receipts.push(urls[0])
		}
	}
}
</script>
